import { FC } from "react";
import { BiX } from "react-icons/bi";

import Diagram from "@lhd/components/Diagram";
import Button from "@lhd/components/Button";
import Loading from "@lhd/components/Loading";
import useBranches, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const BranchesLayout: FC<Props> = ({
  treeData,
  isLoading,
  isSubmitting,
  isEditing,
  onAddNode,
  onSubmit,
  setTreeData,
  updateTreeData,
  removeNode,
  selectThis,
  insertNewNode,
}) => {
  if (isLoading) {
    return <Loading />;
  }

  return (
    <Styles>
      <Diagram
        treeData={treeData}
        setTreeData={setTreeData}
        updateTreeData={updateTreeData}
        removeNode={removeNode}
        selectThis={selectThis}
        insertNewNode={insertNewNode}
        placeholder="支店名を入力ください"
      />

      <div className="footer group-btn">
        <Button
          className="btn-add"
          label="追加"
          disabled={isSubmitting}
          icon={<BiX size={18} />}
          onClick={onAddNode}
        />
        <Button
          className="btn-submit"
          label="保存"
          htmlType
          loading={isSubmitting}
          onClick={onSubmit}
          disabled={!isEditing}
        />
      </div>
    </Styles>
  );
};

const Branches: FC<ReceivedProps> = (props) => (
  <BranchesLayout {...useBranches(props)} />
);

export default Branches;
